"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var checkbox_component_1 = require("./checkbox/checkbox.component");
var date_range_picker_component_1 = require("./date-range-picker/date-range-picker.component");
var email_component_1 = require("./email/email.component");
var masked_input_directive_1 = require("./mask/masked-input.directive");
var number_component_1 = require("./number/number.component");
var password_component_1 = require("./password/password.component");
var phone_component_1 = require("./phone/phone.component");
var radio_group_component_1 = require("./radio/radio-group.component");
var radio_group_service_1 = require("./radio/radio-group.service");
var radio_component_1 = require("./radio/radio.component");
var select_picker_component_1 = require("./select-picker/select-picker.component");
var text_area_component_1 = require("./text-area/text-area.component");
var text_box_component_1 = require("./text-box/text-box.component");
var toggle_component_1 = require("./toggle/toggle.component");
var date_time_picker_component_1 = require("./datetime-picker/date-time-picker.component");
var datetime_picker_popup_component_1 = require("./datetime-picker/datetime-picker-popup.component");
var checkbox_component_2 = require("./checkbox/checkbox.component");
exports.CheckboxComponent = checkbox_component_2.CheckboxComponent;
var date_range_picker_component_2 = require("./date-range-picker/date-range-picker.component");
exports.DateRangePickerComponent = date_range_picker_component_2.DateRangePickerComponent;
var email_component_2 = require("./email/email.component");
exports.EmailComponent = email_component_2.EmailComponent;
var masked_input_directive_2 = require("./mask/masked-input.directive");
exports.MaskedInputDirective = masked_input_directive_2.MaskedInputDirective;
var number_component_2 = require("./number/number.component");
exports.NumberComponent = number_component_2.NumberComponent;
var password_component_2 = require("./password/password.component");
exports.PasswordComponent = password_component_2.PasswordComponent;
var phone_component_2 = require("./phone/phone.component");
exports.PhoneComponent = phone_component_2.PhoneComponent;
var radio_group_component_2 = require("./radio/radio-group.component");
exports.RadioGroupComponent = radio_group_component_2.RadioGroupComponent;
var radio_group_service_2 = require("./radio/radio-group.service");
exports.RadioGroupService = radio_group_service_2.RadioGroupService;
var radio_component_2 = require("./radio/radio.component");
exports.RadioComponent = radio_component_2.RadioComponent;
var select_picker_component_2 = require("./select-picker/select-picker.component");
exports.SelectPickerComponent = select_picker_component_2.SelectPickerComponent;
var text_area_component_2 = require("./text-area/text-area.component");
exports.TextAreaComponent = text_area_component_2.TextAreaComponent;
var text_box_component_2 = require("./text-box/text-box.component");
exports.TextBoxComponent = text_box_component_2.TextBoxComponent;
var toggle_component_2 = require("./toggle/toggle.component");
exports.ToggleComponent = toggle_component_2.ToggleComponent;
var date_time_picker_component_2 = require("./datetime-picker/date-time-picker.component");
exports.DateTimePickerComponent = date_time_picker_component_2.DateTimePickerComponent;
var datetime_picker_popup_component_2 = require("./datetime-picker/datetime-picker-popup.component");
exports.DateTimePickerPopupComponent = datetime_picker_popup_component_2.DateTimePickerPopupComponent;
var MaterialFormsModule = (function () {
    function MaterialFormsModule() {
    }
    return MaterialFormsModule;
}());
MaterialFormsModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
        ],
        declarations: [
            checkbox_component_1.CheckboxComponent,
            date_range_picker_component_1.DateRangePickerComponent,
            date_time_picker_component_1.DateTimePickerComponent,
            datetime_picker_popup_component_1.DateTimePickerPopupComponent,
            email_component_1.EmailComponent,
            masked_input_directive_1.MaskedInputDirective,
            number_component_1.NumberComponent,
            password_component_1.PasswordComponent,
            phone_component_1.PhoneComponent,
            radio_group_component_1.RadioGroupComponent,
            radio_component_1.RadioComponent,
            select_picker_component_1.SelectPickerComponent,
            text_area_component_1.TextAreaComponent,
            text_box_component_1.TextBoxComponent,
            toggle_component_1.ToggleComponent,
        ],
        exports: [
            checkbox_component_1.CheckboxComponent,
            date_range_picker_component_1.DateRangePickerComponent,
            date_time_picker_component_1.DateTimePickerComponent,
            datetime_picker_popup_component_1.DateTimePickerPopupComponent,
            email_component_1.EmailComponent,
            masked_input_directive_1.MaskedInputDirective,
            number_component_1.NumberComponent,
            password_component_1.PasswordComponent,
            phone_component_1.PhoneComponent,
            radio_group_component_1.RadioGroupComponent,
            radio_component_1.RadioComponent,
            select_picker_component_1.SelectPickerComponent,
            text_area_component_1.TextAreaComponent,
            text_box_component_1.TextBoxComponent,
            toggle_component_1.ToggleComponent,
        ],
        providers: [
            radio_group_service_1.RadioGroupService,
        ],
        entryComponents: [datetime_picker_popup_component_1.DateTimePickerPopupComponent],
    }),
    __metadata("design:paramtypes", [])
], MaterialFormsModule);
exports.MaterialFormsModule = MaterialFormsModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/material-forms.module.js
// module id = 43
// module chunks = 0